/*
 * Copyright (c) 2025. Jellybean B.V.
 * Jellybean B.V. Apeldoorn heeft een licentie verleend aan
 * Spin in het Web B.V. Apeldoorn voor het gebruik van deze software-
 * onderdelen in projecten voor derden. U heeft géén toestemming
 * tot inzage of wijziging in de (bron)code van deze onderdelen.
 */

/*
* mdatepipe.ts
* 24-11-2021 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Pipe, PipeTransform} from "@angular/core";
import moment from 'moment';

@Pipe({ name: 'mdate',
  standalone: false})
export class Mdatepipe implements PipeTransform {
  transform(value?: moment.MomentInput, format: string = 'DD-MM-YYYY' ): string | null {
    if (! value)
    {
      return null;
    }
    return moment(value).format(format);
  }
}
